import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryAndDocStatusStatusAllowRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentStatus = control.get('documentStatus')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const documentProcessed = control.get('documentProcessed')!.value;

	return (documentType ===  "EGD000"  || documentCategory ===  "EGD00")  && (documentProcessed !==  "1" &&
	            documentStatus !==  "0")
	         ? { checkDocCategoryAndDocStatusStatusAllowFlag: true } : null;
};
